module.exports = __webpack_public_path__ + "fonts/c1e9a8527a4a4f457a8fdf644d373e9c.eot";